export default "__VITE_ASSET__C0yvw6YC__"